import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const NoOcurrence = ({ message = "Nada consta" }) => {
  return (
    <div className="mt-2 flex items-center gap-3 p-4 bg-green-50 border border-green-200 rounded-lg shadow-sm">
      <IoMdCheckmarkCircleOutline className="text-green-600" size={24} />
      <span className="text-green-800 font-medium text-sm">{message}</span>
    </div>
  );
};

export default NoOcurrence;
